import type { EventVenueMap, VenueDl } from "@tih/shared";
import { useReveal } from "../hooks/useReveal";
import {
  COMING_SOON_VENUE,
  venueDirectionsUrlFrom,
  venueMapEmbedUrlFrom,
} from "../lib/coming-soon-venue";

/** Legacy marketing Venue section fallback when no event venueMap is passed. */
const FALLBACK_VENUE: EventVenueMap = {
  name: COMING_SOON_VENUE.mapTitle,
  address: `${COMING_SOON_VENUE.building}\n${COMING_SOON_VENUE.area}, Uganda`,
  mapsQuery: COMING_SOON_VENUE.mapsQuery,
};

const FALLBACK: VenueDl[] = [
  {
    k: "Address",
    v: `${COMING_SOON_VENUE.building} · ${COMING_SOON_VENUE.area}`,
  },
  { k: "Parking", v: "Free on-site · overflow on Kyaggwe Rd." },
  { k: "Accessibility", v: "Elevator to 2nd floor · wheelchair seating reserved" },
  { k: "Food", v: "Hot tea & mandazi served at 2 AM" },
];

export function Venue({
  details = FALLBACK,
  venueMap = FALLBACK_VENUE,
}: {
  details?: VenueDl[];
  venueMap?: EventVenueMap;
}) {
  const ref = useReveal<HTMLElement>();
  const directionsUrl = venueDirectionsUrlFrom(venueMap);
  const embedUrl = venueMapEmbedUrlFrom(venueMap);
  const addressLines = venueMap.address
    ? venueMap.address
        .split(/\n/)
        .map((s) => s.trim())
        .filter(Boolean)
    : [venueMap.name];

  return (
    <section className="section section-venue" id="venue" ref={ref}>
      <div className="venue-grid">
        <div className="venue-text">
          <div className="sec-eyebrow"><em>the venue</em></div>
          <h2 className="sec-title sec-title-sm">{venueMap.name}</h2>
          <p className="lede-serif">
            {addressLines.map((line, i) => (
              <span key={`${line}-${i}`}>
                {i > 0 ? <br /> : null}
                {line}
              </span>
            ))}
          </p>
          <dl className="venue-dl">
            {details.map((d) => (
              <div key={d.k}>
                <dt>{d.k}</dt>
                <dd>{d.v}</dd>
              </div>
            ))}
          </dl>
          <a
            className="btn btn-primary"
            href={directionsUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get directions
            <span className="arr">↗</span>
          </a>
        </div>
        <div className="venue-map">
          <div className="map-frame">
            <iframe
              title={`Map: ${venueMap.name}`}
              className="coming-soon-map-iframe"
              src={embedUrl}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
